import {styled} from '@mui/system';
import {TabPanel} from '@mui/lab';

export const MuiTabPanel = styled(TabPanel)(() => ({
	paddingLeft: 0,
	paddingRight: 0,
	paddingBottom: 0,
}));
